<template>
    <van-popup
        v-model="show"
        position="center"
        round
        @close="onClose"
    >
        <div class="popup">
            <div class="popup__header" v-html="title"></div>
            <div class="popup__body" v-html="content"></div>
            <div class="popup__footer" :style="{'--themeColor': themeColor}">
                <van-button plain @click="handleCancel">{{ cancelButtonText }}</van-button>
                <van-button @click="handleConfirm">{{ confirmButtonText }}</van-button>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { Popup , Button } from "vant";
export default {
    components: {
        [Popup.name]: Popup,
        [Button.name]: Button
    },
    data(){
        return {
            show: false,
            themeColor: "#EC892E",
            cancelButtonText: "取消",
            confirmButtonText: "确认",
            title: "",
            content: "",
            promiseReject: null,
            promiseResolve: null,
            initialData: {},
        }
    },
    created(){
        this.initialData = this.deepClone(this.$data);
    },
    methods: {
        open(options){
            return new Promise((resolve,reject) => {
                this.reset();
                this.init(options);
                this.promiseReject = reject;
                this.promiseResolve = resolve;
                this.show = true;
            })
        },
        handleConfirm(){
            this.promiseReject = null;
            this.promiseResolve();
            this.show = false;
        },
        handleCancel(){
            this.promiseResolve = null;
            this.show = false;
        },
        reset(){
            Object.keys(this.initialData).map(key => {
                if(key === "initialData") return false;
                this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(this.initialData[key])) 
                ? this.deepClone(this.initialData[key]) : this.initialData[key];
            })
        },
        init(options){
            if(!options) return;
            Object.keys(options).map(key => {
                if(!this.$data.hasOwnProperty(key)) return;
                this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(options[key])) 
                ? this.deepClone(options[key]) : options[key];
            })
        },
        onClose(){
            this.promiseReject && this.promiseReject("cancel");
        }
    }
}
</script>

<style scoped lang="scss">
    .popup {
        width: 85vw;
        padding: 0 18px;
        box-sizing: border-box;
        .popup__header {
            font-size: 18px;
            line-height: 26px;
            color: #3D3833;
            font-weight: bold;
            padding: 36px 0 16px 0;
            text-align: center;
        }
        .popup__body {
            font-size: 14px;
            line-height: 22px;
            color: #3D3833;
            padding-bottom: 20px;
            text-align: center;
        }
        .popup__footer {
            padding: 16px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .van-button {
                min-width: 122px;
                height: 38px;
                box-sizing: border-box;
                border-radius: 4px;
            }
        }
    }
    ::v-deep.van-popup {
        border-radius: 4px !important;
        .van-button--default {
            border-color: var(--themeColor);
            background-color: var(--themeColor);
            .van-button__text {
                font-size: 16px;
                line-height: 24px;
                color: #FFF;
            }
        }
        .van-button--default.van-button.van-button--plain {
            border-color: var(--themeColor);
            background-color: #FFF;
            .van-button__text {
                font-size: 16px;
                line-height: 24px;
                color: var(--themeColor);
            }
        }
    }
</style>